import React from "react";
import {formatNumber, parseDate} from "../../../../utils/react";
import {Button, ButtonTypes, Status, StatusColors} from "icr-shared-components";
import {ReactComponent as IconPdfDownload} from "../../../../assets/icons/pdfdownload.svg";
import styles from "./InvoiceExpandableRowContent.module.scss";
import {RootState} from "../../../../reducers";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

const InvoiceStatusColors = {
    0: StatusColors.HIGHLIGHT,
    1: StatusColors.ERROR,
    2: StatusColors.VERIFICATION,
};

interface InvoiceExpandableRowContentProps {
    intl: any;
    invoice;
    statusOptions;
    openModal;
    entities: any;
}

export const InvoiceExpandableRowContent = ({invoice, entities, statusOptions, openModal}: InvoiceExpandableRowContentProps) => {
    const status = entities?.InvoiceStates?.values?.[invoice.attributes.status];
    return (
        <div className={styles.invoicesExpandableRowTop}>
            <div className={styles.column}>
                <span className={styles.mobileHeader}>Rechngsnummer</span>
                <p><b>{invoice.attributes.invoiceName}</b></p>
            </div>
            <div className={styles.column}>
                <span className={styles.mobileHeader}>Rechnungsdatum</span>
                <p>{parseDate(invoice.attributes.invoiceDate)}</p>
            </div>
            <div className={styles.column}>
                <span className={styles.mobileHeader}>Fälligkeitsdatum</span>
                <p> {parseDate(invoice.attributes.dueDate)}</p>
            </div>
            <div className={styles.column}>
                <span className={styles.mobileHeader}>Betrag</span>
                <p>{invoice.attributes.amount && "CHF " + formatNumber(invoice.attributes.amount)}</p>
            </div>
            <div className={styles.column}>
                <span className={styles.mobileHeader}>Status</span>
                <Status text={status} color={InvoiceStatusColors[invoice.attributes.status]}/>
            </div>
            <div className={styles.column}>
                <Button
                    onClick={() => openModal()}
                    type={ButtonTypes.Text}>
                    <IconPdfDownload />
                </Button>
            </div>
        </div>
    );
}

function mapStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        entities: state.app.entities
    }
}

const connector = connect(mapStateToProps, null);
export default connector(injectIntl(InvoiceExpandableRowContent));
